import script from "./ClassificationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassificationBar.vue?vue&type=script&setup=true&lang=js"

import "./ClassificationBar.vue?vue&type=style&index=0&id=2d74860c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d74860c"]])

export default __exports__